import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

const STORAGE_KEY = "vivendario_cookie_consent_v1";

function updateConsent(granted) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  const state = granted
    ? {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        analytics_storage: "granted",
        functionality_storage: "granted",
        security_storage: "granted",
      }
    : {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied",
        functionality_storage: "granted",
        security_storage: "granted",
      };
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag("consent", "update", state);
  window.dataLayer.push({
    event: "cookie_consent_update",
    consent: granted ? "accepted" : "rejected",
  });
}

export default function CookieBanner() {
  const { lang, t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const existing = localStorage.getItem(STORAGE_KEY);
      if (!existing) setVisible(true);
    } catch (_) {
      setVisible(true);
    }
  }, []);

  const handle = (choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, choice);
    } catch (_) {}
    updateConsent(choice === "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label={t("cookie.title")}
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-50 bg-white border-t border-gray-200"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-8 py-5 flex flex-col md:flex-row md:items-center gap-4">
        <div className="flex-1">
          <p className="text-sm font-semibold text-[#101828]">
            {t("cookie.title")}
          </p>
          <p className="mt-1 text-sm text-[#475467] leading-relaxed">
            {t("cookie.message")}{" "}
            <Link
              to={`/${lang}/cookie-policy`}
              className="underline text-[#1E3A8A]"
              data-testid="cookie-banner-policy-link"
            >
              {t("cookie.policy")}
            </Link>
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 md:justify-end">
          <button
            type="button"
            onClick={() => handle("rejected")}
            data-testid="cookie-banner-reject-btn"
            className="px-4 py-2 text-sm font-semibold border border-gray-300 text-[#101828] bg-white hover:bg-gray-100"
          >
            {t("cookie.reject")}
          </button>
          <button
            type="button"
            onClick={() => handle("accepted")}
            data-testid="cookie-banner-accept-btn"
            className="px-4 py-2 text-sm font-semibold bg-[#1E3A8A] text-white hover:bg-[#1E40AF]"
          >
            {t("cookie.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
